// extracted by mini-css-extract-plugin
module.exports = {"menu":"TaxMenu_menu__d3c91","menumobile":"TaxMenu_menumobile__6AWTs","menu-selected":"TaxMenu_menu-selected__aqRG0"};